const PermisIcon = ({ color, className, ...props}) => (
  <svg
    id="grade"
    style={{ fill: color }}
    viewBox="-2 -2 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class={`MuiSvgIcon-root ${className}`}
    {...props}
  >
    <g data-name="Groupe 2289" id="Groupe_2289" transform="translate(-2 -2)">
      <path
        d="M20,7H15V4a2.006,2.006,0,0,0-2-2H11A2.006,2.006,0,0,0,9,4V7H4A2.006,2.006,0,0,0,2,9V20a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V9A2.006,2.006,0,0,0,20,7ZM13,9H11V4h2Zm4.25,7.5h-2.5a.755.755,0,0,1-.75-.75h0a.755.755,0,0,1,.75-.75h2.5a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,17.25,16.5Zm0-3h-2.5a.755.755,0,0,1-.75-.75h0a.755.755,0,0,1,.75-.75h2.5a.755.755,0,0,1,.75.75h0A.755.755,0,0,1,17.25,13.5Z"
        data-name="Tracé 5884"
        fill="#0060f9"
        id="Tracé_5884"
      />
    </g>
  </svg>
);

export default PermisIcon;
